import { FC, Suspense as ReactSuspense } from 'react'
import Loading from './Loading'

const title = 'Pure Property Management'

interface Props {
  RouteComponent: React.ComponentType
  options?: Record<string, unknown>
  componentProps?: Record<string, unknown>
}

const Suspense: FC<Props> = ({ RouteComponent, options, componentProps }) => {
  const props = {
    ...componentProps,
  }

  const componentOptions = {
    title,
    ...options,
  }

  window.document.title = componentOptions.title

  return (
    <ReactSuspense fallback={<Loading />}>
      <RouteComponent {...props} />
    </ReactSuspense>
  )
}

export default Suspense
